import React from "react"
import ReactDOM from "react-dom/client"
import { AudioProvider } from './AudioProvider_file';


import App from './App'
import './index.css'





//ReactDOM.render(navbar, document.getElementById("root"))

ReactDOM.createRoot(document.getElementById("root")).render(<AudioProvider>
    <App />
  </AudioProvider>,)
